const names = {
    lineWidth: 'Width',
    color: 'Color',
    borderColor: 'Bands Color',
    middleColor: 'Mid Color',
    length: 'Period',
    applyto: 'Apply to',
    offset: 'Offset',
    sigma: 'Sigma',
    percentage: 'Percentage',
    backColor: 'Back Color',
    stddev: 'Deviation',
    bandColor: 'Bands Color',
    upper: 'Upper',
    lower: 'Lower',
    posColor: 'Positive Color',
    negColor: 'Négative Color',
    thresholdSize: 'Threshold Size',
    colors: 'Color',
    smooth: 'Smooth',
    CP: 'Tenkan-sen',
    BP: 'Kijun-sen',
    LSP: 'Senkou Span B',
    DIZ: 'Déplacement',
    baseColor: 'Kijun-sen',
    conversionColor: 'Tenkan-sen',
    laggingColor: 'Chikou Span',
    color1: 'Chikou Span',
    back1: 'Rising Kumo',
    back2: 'Falling Kumo',
    mult: 'Multiplier',
    showMid: 'Show Mid',
    use_tr: 'Use True Range',
    histWidth: 'Histogram Width',
    macdWidth: 'MACD Width',
    signalWidth: 'Signal Width',
    defColor: 'Color',
    macdColor: 'MACD Color',
    signalColor: 'Signal Color',
    histColor: 'Histogramme Color',
    fast: 'Fast EMA',
    slow: 'Slow EMA',
    start: 'Strat',
    number: 'Number',
    step: 'Step',
    param_k: 'K Period',
    param_d: 'D Period',
    kColor: 'K Color',
    dColor: 'D Color',
    long: 'Long',
    short: 'Short',
    signal: 'Signal',
    inc: 'Step',
    max: ' Maximum',
};
export default names;
